import {initHamburger} from './modules/hamburger.js';
import {initHamburgerAccordion} from './modules/hamburgerAccordion.js';
import {initHeaderNavDragPrevention, initHeaderScrolledClass} from './modules/header.js';
import {fadeAnime, delayScrollAnime} from './modules/animation.js';
import {initPageTop} from './modules/page-top.js';

import {initFloatingCta} from './modules/floating-cta.js';
import {initFaq} from './modules/faq.js';

window.addEventListener('load', () => {
  fadeAnime();
  delayScrollAnime();
});

window.addEventListener('scroll', () => {
  fadeAnime();
  delayScrollAnime();
});

document.addEventListener('DOMContentLoaded', () => {
  initHamburger();
  initHamburgerAccordion();
  initHeaderScrolledClass();
  initHeaderNavDragPrevention();
  initPageTop();
  initFloatingCta();
  initFaq();
});
